export type LoadingVariant = 'default' | 'fullscreenBranded';

export interface LoadingProps {
  /** 樣式變體：default 灰底區塊，fullscreenBranded 全屏品牌漸層（如 Survey） */
  variant?: LoadingVariant;
}

export function Loading({ variant = 'default' }: LoadingProps) {
  if (variant === 'fullscreenBranded') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-600 to-indigo-700 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mb-4"></div>
          <p className="text-white text-lg font-semibold">載入中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-4"></div>
        <p className="text-gray-600">載入中...</p>
      </div>
    </div>
  );
}
